export enum Model {
    Unidirectional = 0,
    Bidirectional = 1,
    Tridirectional = 2
}
